var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('ul',_vm._l((_vm.footerLinkItems),function(item){return _c('li',{key:item.id},[_c('a',{staticClass:"footer-link",attrs:{"href":item.url,"target":item.blank ? '_blank' : false}},[_vm._v(_vm._s(item.name))])])}),0),_vm._v(" "),_c('small',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" Lisse")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-986e8470","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_organisms/Footer.vue
// module id = null
// module chunks = 